/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type PWTokenObtainPair = {
    username?: string;
    password?: string;
    mfa_code?: string;
    mfa_method?: PWTokenObtainPair.mfa_method;
}

export namespace PWTokenObtainPair {

    export enum mfa_method {
        EMAIL = 'email',
        SMS = 'sms',
        APP = 'app',
    }


}
